import { useCallback } from "react";

import { useSearchParams } from "react-router-dom";

import { SessionNamespace } from "src/api/agents/debug";
import { AgentSessionDebugKeys } from "src/router/SearchParams";

export type SessionDebugParams = {
  kind: SessionNamespace;
  sessionId: string | null;
};

const isSessionNamespace = (value: string | null): value is SessionNamespace =>
  value === "agent" || value === "copilot";

export const useSessionDebugSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const kindParam = searchParams.get(AgentSessionDebugKeys.Kind);
  const kind: SessionNamespace = isSessionNamespace(kindParam)
    ? kindParam
    : "agent";
  const sessionId = searchParams.get(AgentSessionDebugKeys.SessionId) || null;

  const setDebugParams = useCallback(
    (values: Partial<SessionDebugParams>) => {
      setSearchParams((prev) => {
        const setOrDelete = (
          key: AgentSessionDebugKeys,
          value?: string | null,
        ) => {
          if (value === undefined) return;
          if (value) prev.set(key, value);
          else prev.delete(key);
        };
        setOrDelete(AgentSessionDebugKeys.Kind, values.kind);
        setOrDelete(AgentSessionDebugKeys.SessionId, values.sessionId);
        return prev;
      });
    },
    [setSearchParams],
  );

  return { kind, sessionId, setDebugParams };
};
